<template>
  <div>
      <div v-if="campaignGroupList.length != 0" class="table-responsive" style="text-align: right; font-size: 14px">
        <b>
          <sup>*</sup>
        </b>
        <span style>Last 7 Days</span>
      </div>
      <table class="table" v-if="campaignGroupList.length != 0" style="table-layout:fixed;">
        <thead>
          <tr>
            <!-- <th style = "width:50px">&nbsp;</th> -->
            <th style="width:3%" class="text-center">
              <input
                v-model="actionSelectioncampaignGroupControl"
                type="checkbox"
              />
            </th>
            <th style="width:23%" class="link" v-on:click="sorting('name', $event)">
              Name
              <i
                class="sort fa"
                :class="
                  sort.field == 'name'
                    ? sort.order == 'asc'
                      ? 'fa-arrow-up'
                      : 'fa-arrow-down'
                    : ''
                "
              ></i>
            </th>
            <th
              v-if="showBadge()"
              class="link"
              v-on:click="sorting('budget_flag', $event)"
            >
              Budget
              <i
                class="sort fa"
                :class="
                  sort.field == 'budget_flag'
                    ? sort.order == 'asc'
                      ? 'fa-arrow-up'
                      : 'fa-arrow-down'
                    : ''
                "
              ></i>
            </th>
            <th class="link" v-on:click="sorting('#_of_campaigns', $event)">
              # of Campaigns
              <i
                class="sort fa"
                :class="
                  sort.field == '#_of_campaigns'
                    ? sort.order == 'asc'
                      ? 'fa-arrow-up'
                      : 'fa-arrow-down'
                    : ''
                "
              ></i>
            </th>
            <th class="link" v-on:click="sorting('d_budget', $event)">
              D Budget($)
              <i
                class="sort fa"
                :class="
                  sort.field == 'd_budget'
                    ? sort.order == 'asc'
                      ? 'fa-arrow-up'
                      : 'fa-arrow-down'
                    : ''
                "
              ></i>
            </th>
            <th class="link" style="min-width: 130px;" v-on:click="sorting('impressions', $event)">
              Impressions
              <i
                class="sort fa"
                :class="
                  sort.field == 'impressions'
                    ? sort.order == 'asc'
                      ? 'fa-arrow-up'
                      : 'fa-arrow-down'
                    : ''
                "
              ></i>
              <sup>*</sup>
            </th>
            <th style="min-width:80px" class="link" v-on:click="sorting('clicks', $event)">
              Clicks
              <i
                class="sort fa"
                :class="
                  sort.field == 'clicks'
                    ? sort.order == 'asc'
                      ? 'fa-arrow-up'
                      : 'fa-arrow-down'
                    : ''
                "
              ></i>
              <sup>*</sup>
            </th>
            <th class="link" v-on:click="sorting('sales', $event)">
              Sales
              <i
                class="sort fa"
                :class="
                  sort.field == 'sales'
                    ? sort.order == 'asc'
                      ? 'fa-arrow-up'
                      : 'fa-arrow-down'
                    : ''
                "
              ></i>
              <sup>*</sup>
            </th>
            <th style="min-width: 100px;" class="link" v-on:click="sorting('spend', $event)">
              Spend($)
              <i
                class="sort fa"
                :class="
                  sort.field == 'spend'
                    ? sort.order == 'asc'
                      ? 'fa-arrow-up'
                      : 'fa-arrow-down'
                    : ''
                "
              ></i>
              <sup>*</sup>
            </th>
            <th>Strategy</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in campaignGroupList"
            :key="item.id + '_' + index"
            :class="index%2==0?'even':''"
          >
            <!-- <td></td> -->
            <td class="text-center">
              <input
                type="checkbox"
                :id="item.id"
                :value="item.id"
                v-model="item.checked"
                @change="selected(item)"
              />
            </td>
            <td
              style="
                max-width: 300px;
                -ms-word-break: break-all;
                word-break: break-all;
                word-break: break-word;
                -webkit-hyphens: auto;
                -moz-hyphens: auto;
                hyphens: auto;
              "
            >
              <a
                href="javascript:void(0)"
                @click="navigateToCampaignList(item)"
                style="color: #143A33;"
                >{{ item.name }}</a
              >
            </td>
            <!-- <td><i class="fas fa-dollar-sign"></i></td> -->
            <td v-if="showBadge()">
              <div
                v-if="item.budget_flag"
                style="
                  width: 20px;
                  border-radius: 50%;
                  height: 20px;
                  background-color: red;
                "
              >
                <i
                  class="fas fa-dollar-sign"
                  style="
                    color: white;
                    margin: 2px 0px 2px 5px;
                  "
                ></i>
              </div>
            </td>
            <td>{{ item.totalCampaigns ? item.totalCampaigns : 0 }}</td>
            <td>{{ item.datilyBudget ? item.datilyBudget : 0 }}</td>
            <td>{{ item.totalImpressions ? item.totalImpressions : 0 }}</td>
            <td>{{ item.totalClicks ? item.totalClicks : 0 }}</td>
            <td>{{ item.totalSales ? item.totalSales : 0 }}</td>
            <td>{{ item.totalSpend ? item.totalSpend : 0 }}</td>
            <td v-if="item.objective == 'Sales'">
              <span class="tbl-badge sales" style="background-color: #1d919e;border: solid 1px #1d919e;color:#fff;opacity:1;">Sales</span>
            </td>
            <td v-else-if="item.objective == 'ROI'">
              <span class="tbl-badge roi" style="background-color: #1d919e;border: solid 1px #1d919e;color:#fff;opacity:1;">ROI</span>
            </td>
             <td v-else-if="item.objective == 'vCPM'">
              <span class="tbl-badge vCPM" style="background-color: #1d919e;border: solid 1px #1d919e;color:#fff;opacity:1;">vCPM</span>
            </td>
            <td v-else></td>
            <td>
              <div class="row-add-edit">
              <a
                href="javascript:void(0)"
                class="item-add-edit"
                data-toggle="dropdown"
              ></a>
              <div
                class="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
                style="left: -58px"
              >
                <a
                  class="grid-item ico-edit"
                  @click="openEditCamapign(item.id)"
                  >Edit</a
                >
                <a
                  class="grid-item ico-delete"
                  @click="deleteCampaignGroup(item)"
                  >Delete</a
                >
                <a
                  class="grid-item ico-activity"
                  @click="viewActivityPage(item.id, item.name)"
                  >View Activity</a
                >
                <a class="grid-item ico-activity" @click="addGuardrail(item)"
                  >Create Guardrail</a
                >
              </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
        
      <NoDataAvailable
        v-else
        displayMessage="No Data Is Available"
      ></NoDataAvailable>
        <!-- <CannotDeletePopUp
      :headerMsg="updateHeading(delCampaignGrpName)"
		  deleteMessage = "Cannot Delete Campaign Group as part of a Campaign"
		  /> -->
        <CannotDeletePopUp
          headerMsg="Delete"
          deleteMessage="Cannot Delete Campaign Group as part of a Campaign"
        />
        <DeletePopUp
          v-if="isDeletePopUpOpen"
          @deleteData="deleteData"
          @hideDeleteModal="hideDeleteModal"
          :headerMssg="updateHeading(delCampaignGrpName)"
        />
    
  </div>
</template>

<script>
import moment from "moment";
import DeletePopUp from "../delete/DeletePopUp.vue";
import NoDataAvailable from "../NoDataAvailable.vue";
import CannotDeletePopUp from "../product/CannotDeletePopUp.vue";

export default {
  name: "CampaignGroupListGrid",
  components: {
    DeletePopUp,
    NoDataAvailable,
    CannotDeletePopUp,
  },
  data() {
    return {
      isDeletePopUpOpen: false,
      delCampaignId: "",
      delCampaignGrpName: "",
    };
  },
  props: {
    // campaignGroupList: {
    //   type: Array,
    // },
  },
  watch: {
    campaignGroupSelectedList() {},
  },
  computed: {
    sort: {
      set(val) {
        this.$store.commit("setSelectedSortOrder", val);
      },
      get() {
        return this.$store.state.selectedSortOrder;
      },
    },
    campaignGroupList: {
      set(val) {
        this.$store.state.campaign.campaignGroupList = val;
      },
      get() {
        return this.$store.state.campaign.campaignGroupList;
      },
    },
    actionSelectioncampaignGroupControl: {
      set(val) {
        this.$store.state.campaign.actionSelectioncampaignGroupControl = val;
        if (val) {
          this.selectAllCampaignGroup();
        } else {
          this.resetSelectAllCampaignGroup();
        }
      },
      get() {
        return this.$store.state.campaign.actionSelectioncampaignGroupControl;
      },
    },
    campaignGroupSelectedList: {
      set(val) {
        this.$store.state.campaign.campaignGroupSelectedList = val;
      },
      get() {
        if (this.$store.state.campaign.campaignGroupSelectedList.length == 0) {
          this.resetSelectAllCampaignGroup();
        }
        return this.$store.state.campaign.campaignGroupSelectedList;
      },
    },
  },
  methods: {
    moment,
    showBadge() {
      let showDate = moment().endOf("month").subtract(6, "days");
      if (moment().isBefore(showDate)) {
        return false;
      } else {
        return true;
      }
    },
    updateHeading(data) {
      if (data && data != "") {
        data = 'Delete "' + data + '"';
        return data;
      } else {
        return "Delete";
      }
    },
    viewActivityPage(campGrpId, campGrpName) {
      this.$router.push({
        path:
          "/activityList/campaignGroup/" + campGrpId + "/" + btoa(campGrpName),
      });
    },
    sorting(field, event) {
      this.$store.state.campaign.actionSelectioncampaignGroupControl = false;
      this.$store.state.campaign.campaignGroupSelectedList = [];
      if (
        event.currentTarget.children[0].classList[2] == "fa-arrow-up" ||
        event.currentTarget.children[0].classList[2] == "fa-arrow-down"
      ) {
        var pastEvent = true;
      }
      for (var i = 0; i < document.getElementsByClassName("sort").length; i++) {
        document
          .getElementsByClassName("sort")
          [i].classList.remove("fa-arrow-up");
        document
          .getElementsByClassName("sort")
          [i].classList.remove("fa-arrow-down");
      }
      if (pastEvent) {
        this.sort.order == "desc"
          ? event.currentTarget.children[0].classList.add("fa-arrow-up")
          : event.currentTarget.children[0].classList.add("fa-arrow-down");
        pastEvent = false;
      } else {
        event.currentTarget.children[0].classList.add("fa-arrow-up");
      }

      this.sort = {
        field: field,
        order:
          event.currentTarget.children[0].classList[2] == "fa-arrow-up"
            ? "asc"
            : "desc",
      };

      // this.$store.state.sort.field = field;
      // this.$store.state.sort.order = (event.currentTarget.children[0].classList[2]) == 'fa-angle-up' ? 'asc':'desc';
    },
    navigateToCampaignList(item) {
      this.sort = {
        field: "",
        order: "asc",
      };
      this.$router.push({ path: "/campaignList/" + item.id });
    },
    deleteCampaignGroup(item) {
      this.delCampaignId = item.id;
      this.delCampaignGrpName = item.name;
      if (item.totalCampaigns > 0) {
        $("#cannotDelete").modal("show");
        this.delCampaignId = "";
        this.delCampaignGrpName = "";
      } else {
        this.isDeletePopUpOpen = true;
      }
    },
    deleteData() {
      //
      let vm = this;
      vm.isDeletePopUpOpen = false;
      this.delCampaignGrpName = "";
      this.$store.commit("showLoadingSpinner", null, {
        root: true,
      });
      this.$store
        .dispatch("campaign/deleteCampaignGroup", this.delCampaignId)
        .then((res) => {
          vm.$store.state.campaign.actionSelectioncampaignGroupControl = false;
          vm.$store.state.campaign.campaignGroupSelectedList = [];
          console.log("Deleted");
          let payload = {};
          vm.$store.dispatch("campaign/getCampaignGroupList").then((res) => {
            console.log("Called");
          });
        });
    },
    hideDeleteModal() {
      this.isDeletePopUpOpen = false;
      this.delCampaignGrpName = "";
    },
    openEditCamapign(id) {
      this.$emit("showEditCampaign", id);
    },
    selectAllCampaignGroup() {
      this.campaignGroupSelectedList = [];
      let data = JSON.parse(JSON.stringify(this.campaignGroupList));
      let vm = this;
      data.forEach((element) => {
        element.checked = true;
        vm.campaignGroupSelectedList.push(element);
      });

      this.campaignGroupList = JSON.parse(JSON.stringify(data));
    },
    resetSelectAllCampaignGroup() {
      let data = JSON.parse(JSON.stringify(this.campaignGroupList));
      data.forEach((element) => {
        element.checked = false;
      });
      this.campaignGroupList = JSON.parse(JSON.stringify(data));
      this.campaignGroupSelectedList = [];
    },
    selected(item) {
      let data = this.$store.state.campaign.campaignGroupSelectedList;
      if (item.checked) {
        data.push(item);
      } else {
        let index = data.indexOf(item);
        if (index > -1) {
          data.splice(index, 1);
        }

        this.$store.state.campaign.actionSelectioncampaignGroupControl = false;
      }
    },
    addGuardrail(item) {
      this.openGuardrail(item)
    },
    openGuardrail(item){
      this.actionSelectioncampaignGroupControl = false;
      this.campaignGroupSelectedList = [];
      this.campaignGroupSelectedList.push(item);
      this.$router.push({
        path: '/addEditGuardrail/' + 'null' + '/myAutomation' + '/campaign_group'
      });
    }
  },
};
</script>

<style lang="scss">
.link {
  cursor: pointer;
}
</style>
